var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { QuestionTypeName } from '../../learnware/LearnwareEnums';
export class DirectiveFinishQuestion {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get directive() {
        return this.parent;
    }
    get app() {
        return this.directive.app;
    }
    get question() {
        return this.app.question;
    }
    get answer() {
        return this.app.answer;
    }
    finishAnswer() {
        const { isShowingLastQuestion } = this.app.cycle.cycleInfo; // destructure before setting to finished
        this.answer.finishDate = this.app.appClock.currentDate;
        if (this.question.context.app.appInfo.isMobileAppWebView) {
            this.question.context.app.api.apiNativeApp.sendFinishedEventToWebView();
            return;
        }
        if (!this.app.tray.trayAnswers.answersPosed.includes(this.answer) &&
            this.answer.question.questionType !== QuestionTypeName.CycleEnd) {
            this.app.history.historyRecentAnswers.answersFinishedSincePageLoad.push(this.answer);
        }
        if (isShowingLastQuestion && this.app.cycle.cycleBranding.doesCycleHaveABranding) {
            this.directive.directivePoseQuestion.poseAnswer(this.app.cycle.cycleBranding.brandingAnswer);
            return;
        }
        if (isShowingLastQuestion && this.app.cycle.cycleReward.doesCycleHaveAReward) {
            this.directive.directivePoseQuestion.poseAnswer(this.app.cycle.cycleReward.rewardAnswer);
            return;
        }
        this.directive.directivePoseQuestion.poseNextAnswerInLine();
    }
}
__decorate([
    action.bound
], DirectiveFinishQuestion.prototype, "finishAnswer", null);
